import { useEffect, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import { transformFailedCasesData } from "../../../../utils/helper";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

export const useFailedCasesByCompany = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies } = filterParams;
    const { getData, isLoading } = useAxios();
    const [failedCasesData, setFailedCasesData] = useState([]);

    useEffect(() => {
        const fetchFailedCases = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;
            const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies });
            try {
                const response = await getData(`${baseUrl.failedAnalytics}?${query}`);
                const transformedData = transformFailedCasesData(response);
                setFailedCasesData(transformedData);
            } catch (error) {
                console.error("Error fetching failed cases:", error);
                setFailedCasesData([]);
            }
        };
        fetchFailedCases();
    }, [selectedRange, getData, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies]);

    const totalFailedCases = failedCasesData.reduce(
        (sum, item) => sum + (item.failedCasesCount || 0),
        0
    );

    return {
        isFailedCasesLoading: isLoading,
        totalFailedCases,
        failedCasesData
    };
};
